<template>
    <router-view/>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: '',
    titleTemplate (title) {
      if (!title) {
        return 'Foodsoft'
      }
      return `${title} - Foodsoft`
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles/index";
</style>
